import { render, staticRenderFns } from "./auth-bind.vue?vue&type=template&id=3565ac14&scoped=true&"
import script from "./auth-bind.vue?vue&type=script&lang=js&"
export * from "./auth-bind.vue?vue&type=script&lang=js&"
import style0 from "./auth-bind.vue?vue&type=style&index=0&id=3565ac14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3565ac14",
  null
  
)

export default component.exports